/**
 * Lets the tab strip know whether the current page has an explorer tree, and lets the user
 * show / hide it. Provided by DashboardLayout; ExplorerLayout registers itself while mounted.
 */
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const ExplorerContext = createContext({ present: false, open: true, toggle: () => {}, register: () => () => {} });

export function ExplorerProvider({ children }) {
  const [presentCount, setPresentCount] = useState(0);
  const [open, setOpen] = useState(() => {
    try { return localStorage.getItem('lms_explorer_open') !== '0'; } catch { return true; }
  });
  useEffect(() => { try { localStorage.setItem('lms_explorer_open', open ? '1' : '0'); } catch { /* ignore */ } }, [open]);
  const register = useCallback(() => {
    setPresentCount((n) => n + 1);
    return () => setPresentCount((n) => Math.max(0, n - 1));
  }, []);
  const value = useMemo(() => ({ present: presentCount > 0, open, toggle: () => setOpen((v) => !v), setOpen, register }), [presentCount, open, register]);
  return <ExplorerContext.Provider value={value}>{children}</ExplorerContext.Provider>;
}

export const useExplorerState = () => useContext(ExplorerContext);
